"use strict";
/**
 * 金额工具
 * -----------------------------------------------------------------------------
 * **金额一律以「分」为单位存整数，禁止浮点参与运算。**
 * 见 docs/01-scope/01-一期口径基准.md C-04、docs/02-domain/03-缴费与流水匹配.md §4.3
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.yuanToCents = yuanToCents;
exports.centsToYuan = centsToYuan;
exports.formatCents = formatCents;
/** 元 → 分。仅用于解析人工输入的金额 */
function yuanToCents(yuan) {
    const n = typeof yuan === 'string' ? Number(yuan) : yuan;
    if (!Number.isFinite(n))
        throw new Error('金额格式非法');
    // 用四舍五入规避 0.1 + 0.2 类浮点误差
    return Math.round(n * 100);
}
/** 分 → 元（数值） */
function centsToYuan(cents) {
    assertIntegerCents(cents);
    return cents / 100;
}
/**
 * 格式化展示：分 → `¥1,280.00`
 * 界面展示统一使用本函数，禁止自行拼接。
 */
function formatCents(cents, withSymbol = true) {
    assertIntegerCents(cents);
    const sign = cents < 0 ? '-' : '';
    const abs = Math.abs(cents);
    const yuan = Math.floor(abs / 100);
    const fen = String(abs % 100).padStart(2, '0');
    const grouped = yuan.toLocaleString('zh-CN');
    return `${sign}${withSymbol ? '¥' : ''}${grouped}.${fen}`;
}
function assertIntegerCents(cents) {
    if (!Number.isInteger(cents)) {
        throw new Error(`金额必须为整数分，收到 ${cents}`);
    }
}
//# sourceMappingURL=money.js.map